module.exports = __webpack_public_path__ + "static/media/superman-punch.ddb3f925.png";